import React from "react";

function SiteFooter({ onOpenCookieSettings }) {
  return (
    <footer className="site-footer">
      <p className="site-footer-links">
        <a
          href="#cookie-settings"
          onClick={(event) => {
            event.preventDefault();
            onOpenCookieSettings();
          }}
        >
          Cookie settings
        </a>
        {" "}
        | {" "}
        <a href="/cookies">Cookies page</a>
        {" "}
        | {" "}
        <a href="/privacy">Privacy policy</a>
        {" "}
        | {" "}
        <a href="/terms">Terms of use</a>
        {" "}
        | {" "}
        <a href="/disclaimer">Full disclaimer</a>
      </p>
    </footer>
  );
}

export default SiteFooter;
